/**
 * Apply Form Module
 *
 * @file applyForm.js
 */
import $ from 'jquery';
const applyForm = (() => {
  /**
   *
   * @param {string} name
   */
  const getData = (name) => {
    const data = name;
    return data;
  };

  const formValidate = () => {
    $("#login-form").validate();
  };

  const activationForm = () => {
    var multipleNumber = $(".multiple-number");
    if (multipleNumber.is(":visible")){
      $('form').on('input', e => {
        var letters = ['in-nm-a', 'in-nm-b', 'in-nm-c', 'in-nm-d', 'in-nm-e'];
        letters.forEach(letter => {
          let field = $(e.target);
          field.val(field.val().replace(/[^0-9]/g, ''));
          if(field.val().length == field.attr('maxlength')) { field.nextAll('input').first().focus(); }
        });
      });
    }



    // var countdownSeconds = 240; 
    // if (document.getElementById('countdown')) {
      
    //   var countdownInterval = setInterval(function() {
    //     countdownSeconds--;
    //     document.getElementById('countdown').innerHTML = countdownSeconds + 's';
    //     if (countdownSeconds <= 0) {
    //       clearInterval(countdownInterval);
    //       $(".multiple-number").addClass("error");
    //       // document.getElementById('countdown').innerHTML = 'Countdown Expired';
    //     }
    //   }, 1000);
    // }
  };

  const modalLs = () => {
    var mdModalOpenBtn = document.querySelector('.open-md-modal');
    var mdModalCloseBtn = $('.md-modal-close, .md-modal-bg');
    if(mdModalOpenBtn){
      mdModalOpenBtn.addEventListener("click", function(e) {
        var modalMdL = $(e.target.hash);
        modalMdL.addClass("show-md-modal");
        $("body").addClass("hidden");
        e.preventDefault();
      });

      mdModalCloseBtn.on("click", function(e) {
        $(this).parents(".md-modal").removeClass("show-md-modal");
        $("body").removeClass("hidden");
      });
    }

  };

  const mobileFilter = () => {
    // var mdFilterOpenBtn = $('.filter-title');
    // var mdFilterCloseBtn = $('.mobile-filter-close');
    // if(mdFilterOpenBtn){
    //   mdFilterOpenBtn.on("click", function(e) {
    //     $(".filter-select-container").addClass("show-filter");
    //     $(".left-select-menu").addClass("show-filter-content");
    //     $("body").addClass("hidden");
    //   });

    //   mdFilterCloseBtn.on("click", function(e) {
    //     $(".filter-select-container").removeClass("show-filter");
    //     $(".left-select-menu").addClass("show-filter-content");
    //     $("body").removeClass("hidden");
    //   });
    // }
  };

  const userMobileMenu = () => {
    $(".mobile-user-left-menu").on("click", function(){
      $(".user-left-menu nav").toggle();
    });

    $(".user-left-menu ul li.sub-menu-active").on("click", function(){
      $(this).find(".sub-menu").toggle();
    });
  };

  const userFileCustomName = () => {
    var inputFileItem = $(".custom-file-inp input[type='file']");
    inputFileItem.on("change", function(){
      var $thisFileName = $(this)[0].files[0].name;
      $(this).parent(".custom-file-inp").find("span").html($thisFileName);
    })
  };

  const userVideoInterviewFileCustomName = () => {
    var inputFileItem = $(".interview-box .custom-file-inp-file input[type='file']");
    inputFileItem.on("change", function(){
      var $thisFileName = $(this)[0].files[0].name;
      $(this).parent(".interview-box .custom-file-inp-file").find(".custom-file-inp-text").html($thisFileName);
    })
  };

  const userCvUpload = () => {
    var inputFileItem = $(".upload-to-cv input[type='file']");
    inputFileItem.on("change", function(){
      var $thisFileName = $(this)[0].files[0].name;
      $(this).parent(".upload-to-cv").find(".upload-file-name").html($thisFileName);
      $(this).parent(".upload-to-cv").find(".upload-cv-btn").prop("disabled", false);
    })
  };

  const userModal = () => {
    var usModalOpenBtn = $('.us-modal-open');
    var usModalCloseBtn = $('.us-modal-backdrop, .us-modal-cancel, .us-modal-close');
    if(usModalOpenBtn){
      usModalOpenBtn.on("click", function(e) {
        $(".us-modal"+$(this).attr("data-modal")).addClass("show-modal");
        $("body").addClass("hidden");
      });

      usModalCloseBtn.on("click", function(e) {
        $(".us-modal").removeClass("show-modal");
        $("body").removeClass("hidden");
      });
    }
  };

  const positionInputFilter = () => {
    // document.addEventListener('DOMContentLoaded', function () {
    //   var searchInputs = document.querySelectorAll('.filter-select .col-list .col-search input');
    //   var itemContainers = document.querySelectorAll('.filter-select .col-list .check-list');
    //   var closeIcons = document.querySelectorAll('.col-search svg');

    //   // SVG öğelerine tıklama olayını ekleyin
    //   closeIcons.forEach(function (icon) {
    //       icon.addEventListener('click', function () {
    //           // İlgili SVG'ye tıklandığında, ilişkili input alanlarını temizleyin
    //           console.log("asd");
    //           var parentFilter = icon.closest('.col-search');
    //           var inputFields = parentFilter.querySelectorAll('.col-search input[type="text"]');
              
    //           inputFields.forEach(function (input) {
    //               input.value = ''; // Input alanını temizle
    //           });
    //           filterItems();
    //       });
    //   });
  
    //   searchInputs.forEach(function (searchInput) {
    //       searchInput.addEventListener('input', function () {
    //           filterItems();
    //       });
    //   });
  
    //   function normalizeText(text) {
    //     // Türkçe karakterleri düzeltme
    //     var normalizedText = text
    //         .replace(/Ğ/g, 'g')
    //         .replace(/Ü/g, 'u')
    //         .replace(/Ş/g, 's')
    //         .replace(/I/g, 'i')
    //         .replace(/İ/g, 'i')
    //         .replace(/Ö/g, 'o')
    //         .replace(/Ç/g, 'c')
    //         .replace(/ğ/g, 'g')
    //         .replace(/ü/g, 'u')
    //         .replace(/ş/g, 's')
    //         .replace(/ı/g, 'i')
    //         .replace(/i/g, 'i')
    //         .replace(/ö/g, 'o')
    //         .replace(/ç/g, 'c');
    //     return normalizedText.toLowerCase();
    // }
  
    //   function filterItems() {
    //       itemContainers.forEach(function (itemContainer) {
    //           var searchInputsInContainer = itemContainer.parentElement.querySelectorAll('.col-search input');
    //           var searchValues = Array.from(searchInputsInContainer).map(function (input) {
    //               return normalizeText(input.value);
    //           });
  
    //           var checkboxes = itemContainer.querySelectorAll('.custom-check input');
    //           var selectedCheckboxes = Array.from(checkboxes).filter(function (checkbox) {
    //               return checkbox.checked;
    //           }).map(function (checkbox) {
    //               return normalizeText(checkbox.value);
    //           });
  
    //           itemContainer.querySelectorAll('.custom-check').forEach(function (item) {
    //               var itemName = normalizeText(item.querySelector('.nm').textContent);
    //               var checkboxValue = normalizeText(item.querySelector('input').value);
  
    //               var searchFilter = searchValues.length === 0 || searchValues.every(function (searchValue) {
    //                   return itemName.includes(searchValue) || checkboxValue.includes(searchValue);
    //               });
  
    //               var checkboxFilter = selectedCheckboxes.length === 0 || selectedCheckboxes.includes(checkboxValue);
  
    //               if (searchFilter && checkboxFilter) {
    //                   item.style.display = 'flex';
    //               } else {
    //                   item.style.display = 'none';
    //               }
    //           });
    //       });
    //   }
    // });
  };

  /**
   * init module
   */
  const init = () => {
    getData('data');
    activationForm();
    modalLs();
    mobileFilter();
    userModal();
    userMobileMenu();
    userFileCustomName();
    userCvUpload();
    positionInputFilter();
    userVideoInterviewFileCustomName();
  };

  return {
    init,
  };
})();

export default applyForm;
